import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';

export const Footer = () => {
  const logoUrl = '/logo_white.png';

  return (
    <footer style={{ backgroundColor: '#303040' }}>
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src={logoUrl}
              alt="TheApostrophe - Regulatory Affairs Specialists for Global Markets"
              className="h-12 w-auto mb-6"
            />
            <p className="text-white/70 mb-6 leading-relaxed">
              Your trusted partner for regulatory affairs in Africa, Asia, GCC & Latin America.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/theapostrophe/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                style={{ backgroundColor: '#0077B5' }}
                aria-label="Visit our LinkedIn page"
              >
                <Linkedin className="h-5 w-5 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-white/70 hover:text-white transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/70 hover:text-white transition-colors duration-200">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/success-packs" className="text-white/70 hover:text-white transition-colors duration-200">
                  Success Packs
                </Link>
              </li>
              <li>
                <Link to="/launch-program" className="text-white/70 hover:text-white transition-colors duration-200">
                  Launch Program
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-white transition-colors duration-200">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Markets */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Markets</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/regions/africa" className="text-white/70 hover:text-white transition-colors duration-200">
                  Africa
                </Link>
              </li>
              <li>
                <Link to="/regions/asia" className="text-white/70 hover:text-white transition-colors duration-200">
                  Asia
                </Link>
              </li>
              <li>
                <Link to="/regions/gcc" className="text-white/70 hover:text-white transition-colors duration-200">
                  GCC
                </Link>
              </li>
              <li>
                <Link to="/regions/latam" className="text-white/70 hover:text-white transition-colors duration-200">
                  Latin America
                </Link>
              </li>
              <li>
                <Link to="/countries" className="text-white/70 hover:text-white transition-colors duration-200">
                  All Countries
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Get In Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 mt-1" style={{ color: '#A060B0' }} />
                <div className="flex flex-col gap-1">
                  <a href="mailto:purva.shah@theapostrophe.in" className="text-white/70 hover:text-white transition-colors duration-200">
                    purva.shah@theapostrophe.in
                  </a>
                  <a href="mailto:hello@theapostrophe.in" className="text-white/70 hover:text-white transition-colors duration-200">
                    hello@theapostrophe.in
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 mt-1" style={{ color: '#A060B0' }} />
                <a href="tel:+919714485551" className="text-white/70 hover:text-white transition-colors duration-200">
                  +91-9714485551
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 mt-1" style={{ color: '#A060B0' }} />
                <span className="text-white/70">
                  B-319, Aarohi Galleria<br />
                  South Bopal<br />
                  Ahmedabad 380058, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t" style={{ borderColor: 'rgba(255, 255, 255, 0.1)' }}>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © 2025 TheApostrophe. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-white/60 hover:text-white text-sm transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-white/60 hover:text-white text-sm transition-colors duration-200">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};